// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetSideWorkersContent-moduleitemsListTitleWrapper__xQh3s WidgetContentItemsList-moduletitleWrapper__Wdg5G";
export { _1 as "itemsListTitleWrapper" }
